/**
 * Generalized Calls
 */
$(document).on("ready", function () {
  $(document).on("click", ".ajax-overlay", function (e) {
    e.preventDefault();
    var $this = $(this);
    var call = $this.data("get");
    var id = call;
    if ($this.data("olClass")) id = $this.data("olClass");
    if ($this.data("requiredState")) {
      if (!$this.hasClass($this.data("requiredState"))) return false;
    }
    var ajax_call=call.replaceAll('-','_');
    addWaiting();
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: { action: 'fw_'+ajax_call+'_ajax', which: $(this).data("for") },
      dataType: "html",
      success: function (data) {
        addOverlay(id, data);
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });

  function ShowMore() {
    $('.truncate').each(function () {
      const $element = $(this);
      if($element.hasClass('is-truncated')){
          return;
      }
      const maxLength = parseInt($element.data('length'), 10); // Get max length from data attribute

      // Store the original HTML content
      const originalHtml = $element.html();
      const originalText = $element.text(); // Get plain text for length check

      // Function to truncate text while preserving HTML tags
      function truncateHtml(element, maxLength) {
        let totalLength = 0;
        let truncatedHtml = '';

        element.contents().each(function () {
          const $node = $(this);

          // If it's a text node (nodeType === 3)
          if ($node[0].nodeType === 3) {
            const textContent = $node.text();

            if (totalLength + textContent.length > maxLength) {
              const remainingLength = maxLength - totalLength;
              truncatedHtml += textContent.substring(0, remainingLength) + '\u2026'; // Truncate text node and add ellipsis
              totalLength = maxLength;
              return false; // Stop further processing once we've reached maxLength
            } else {
              truncatedHtml += textContent;
              totalLength += textContent.length;
            }
          } else { // Element node (e.g., <strong>, <span>)
            const nodeTextLength = $node.text().length;

            if (totalLength + nodeTextLength > maxLength) {
              const remainingLength = maxLength - totalLength;

              // Clone the element to preserve its structure and truncate its content
              const $clonedNode = $node.clone();
              $clonedNode.html(truncateHtml($clonedNode, remainingLength)); // Recursively truncate the content inside this node

              truncatedHtml += $('<div>').append($clonedNode).html(); // Safely append truncated child HTML
              totalLength = maxLength;
              return false; // Stop further processing
            } else {
              truncatedHtml += $('<div>').append($node.clone()).html(); // Add full element if it fits
              totalLength += nodeTextLength;
            }
          }
        });

        $element.addClass('is-truncated');
        return truncatedHtml;
      }

      // Only proceed if the text exceeds maxLength
      if (originalText.length > maxLength) {
        const truncatedHtml = truncateHtml($element, maxLength); // Generate truncated content

        // Create containers for full and truncated content
        const $truncatedContent = $('<div class="truncated-content"></div>').html(truncatedHtml);
        const $fullContent = $('<div class="full-content"></div>').html(originalHtml).hide(); // Hidden by default

        // Set the truncated HTML content initially
        $element.html('').append($truncatedContent).append($fullContent);

        // Create the 'read more' link
        const $readMore = $('<div class="read-more"><a href="#" class="read_more">read more</a></div>');
        $element.append(' ').append($readMore);
      }
    });
  }

  // Initialize ShowMore functionality on page load
  ShowMore();

  // Event delegation for 'read more' and 'read less' click handling
  $(document).on('click', '.read_more', function (e) {
    e.preventDefault();
    const $readMore = $(this);
    const $element = $readMore.closest('.truncate');
    const $truncatedContent = $element.find('.truncated-content');
    const $fullContent = $element.find('.full-content');

    // Toggle between showing truncated and full content
    if ($readMore.text() === 'read more') {
      $truncatedContent.hide();
      $fullContent.show();
      $readMore.text('read less');
    } else {
      $truncatedContent.show();
      $fullContent.hide();
      $readMore.text('read more');
    }
  });

  // Reinitialize for dynamically added elements via AJAX 
$(document).on('ajaxComplete', function () { 
    ShowMore(); // Reapply for any new "truncate" elements 
    initInfoTooltips(); // Rebind events to new info buttons injected by AJAX
});



  $(document).on('click','.fwDoc',function(e){
    e.preventDefault();
    var $this=$(this);
    let url=$this.data('url');
    if(!url){
      url=$this.attr('href');
    }

    window.open('/wp-json/mega-pathway/v1/get-fw-doc?url=' + encodeURIComponent(url), '_blank');
  });
  
// Isolated Tooltip Engine Function
function initInfoTooltips() {
    document.querySelectorAll('.info-btn').forEach(btn => {
        // Prevent duplicate listener stacking on subsequent AJAX cycles
        if (btn.classList.contains('js-tooltip-bound')) return;
        btn.classList.add('js-tooltip-bound');

        // Handles both nested tooltips and un-nested tooltips linked via aria-describedby
        let tooltip = btn.querySelector('.tooltip-box');
        if (!tooltip) {
            const tooltipId = btn.getAttribute('aria-describedby');
            if (tooltipId) {
                tooltip = document.getElementById(tooltipId);
            }
        }

        const setExpanded = (state) => { 
            btn.setAttribute('aria-expanded', String(state)); 
            if (state && tooltip) { 
                // 1. Reset positions to pull clean dimensions
                tooltip.style.left = '50%'; 
                tooltip.style.right = 'auto'; 
                tooltip.style.transform = 'translateX(-50%)'; 

                // 2. Calculate coordinates
                const rect = tooltip.getBoundingClientRect(); 
                const windowWidth = window.innerWidth; 
                const padding = 15; 

                // 3. Right boundary check
                if (rect.right > windowWidth) { 
                    const overlap = rect.right - windowWidth + padding; 
                    tooltip.style.left = 'auto'; 
                    tooltip.style.right = `-${(btn.offsetWidth / 2) - overlap}px`; 
                    tooltip.style.transform = 'none'; 
                } 

                // 4. Left boundary check
                if (rect.left < 0) { 
                    const overlap = Math.abs(rect.left) + padding; 
                    tooltip.style.left = `-${(btn.offsetWidth / 2) - overlap}px`; 
                    tooltip.style.transform = 'none'; 
                } 
            } 
        }; 

        // Interactive toggle execution
        btn.addEventListener('click', (e) => { 
            e.preventDefault(); 
            const expanded = btn.getAttribute('aria-expanded') === 'true'; 
            document.querySelectorAll('.info-btn').forEach(b => b.setAttribute('aria-expanded', 'false')); 
            setExpanded(!expanded); 
        }); 

        // Focus, hover, and blur states
        btn.addEventListener('mouseenter', () => setExpanded(true)); 
        btn.addEventListener('focus', () => setExpanded(true)); 
        btn.addEventListener('mouseleave', () => { 
            if (document.activeElement !== btn) setExpanded(false); 
        }); 
        btn.addEventListener('blur', () => setExpanded(false)); 
    });
}

// Initial engine fire for native hardcoded elements on page load
initInfoTooltips();

  // Global Escape listener
  document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
          const openBtn = document.querySelector('.info-btn[aria-expanded="true"]');
          if (openBtn) {
              openBtn.setAttribute('aria-expanded', 'false');
              openBtn.focus();
          }
      }
  });
});


